import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Select} from '@material-ui/core';
import connect from "react-redux/es/connect/connect";
import Switch from '@material-ui/core/Switch';


import { getServiceOrderDetail, getServiceOrderProcessDetail, getServiceOrderServiceDetail } from "../../../actions/orderActions";
import {addServiceOrders} from "../../../actions/serviceOrderStatistics";
import {addAutoclaveCicloOrdemServico} from "../../../actions/autoclaveActions";
import PneuFabricanteSelector from "../../../components/pneus/pneuFabricanteSelector";
import PneuModeloSelector from "../../../components/pneus/pneuModeloSelector";
import PneuMedidaSelector from "../../../components/pneus/pneuMedidaSelector";
import BandaSelector from "../../../components/pneus/bandaSelector";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(1) * 10,
    width: '100%'
  },
  relative: {
    position: 'relative'
  },
  textControl : {
    paddingTop: 0,
    paddingBottom: 5,
  },
  switchControl : {
    width: 58,
    height: 38,
    display: 'inline-flex',
    padding: 12,
    zIndex: 0,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 0,
    verticalAlign: 'middle',
    paddingBottom: 5,
  },
  tableTextField: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0'
    },
    '& input': {
      padding: '20px'
    }
  },
  row: {
    marginBottom: theme.spacing(1),
  },
  alertError: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
  }
}));

const FullScreenDialog = ({
                              isOpen,
                              isAddNewRecord,
                              cicloDetalhes,
                              selectedRow,
                              closeDialog,
                              getServiceOrderDetail,
                              getServiceOrderProcessDetail,
                              processData,
                              getServiceOrderServiceDetail,
                              serviceId,
                              orderDetails,
                              TireBands,
                              TireBrands,
                              TireModels,
                              TireSizes,
                              addServiceOrders,
                              addAutoclaveCicloOrdemServico,
                              autoclave,
                              ciclo,
                              selectciclo,
                            autoclaveCodigo
}) => {


  const classes = useStyles();
  const [addNewRecord, setaddNewRecord] = React.useState(isAddNewRecord ? isAddNewRecord : false);
  const [open, setOpen] = React.useState(isOpen);
  const [OSEtapa, setOSEtapa] = React.useState(null);
  const [osCodigo, setOrderId] = React.useState('');
  const [posicao, setPosicao] = React.useState('');
  const [marca, setMarca] = React.useState(null);
  const [modelo, setModelo] = React.useState(null);
  const [listaModelo, setListaModelo] = React.useState(null);
  const [banda, setBanda] = React.useState(null);
  const [medida, setMedida] = React.useState(null);
  const [envelope, setEnvelope] = React.useState('');
  const [almofada, setAlmofada] = React.useState('');
  const [inner, setInner] = React.useState('');
  const [descricao, setDescricao] = React.useState('');
  const [sacoDeAr, setSacoDeAr] = React.useState('');
  const [dot, setDot] = React.useState('');
  const [marcaFogo, setMarcaFogo] = React.useState('');
  const [vida, setVida] = React.useState('');
  const [reprocesso, setReprocesso] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState({});
  const [successMessage, setSuccessMessage] = React.useState('');
  let timeout = null;






  // Sincronizar estado open com prop isOpen
  useEffect( () => {
    setOpen(isOpen);
    setErrors({});
    setSuccessMessage('');
  }, [ isOpen ]);

  // Adicionar nova função de reset que limpa todos os campos
  const resetAllForm = () => {
    setOrderId('');
    setPosicao('');
    setAlmofada('');
    setInner('');
    setDescricao('');
    setSacoDeAr('');
    setEnvelope('');
    setVida('');
    setModelo('');
    setMarca(null);
    setBanda('');
    setMedida('');
    setDot('');
    setMarcaFogo('');
    setReprocesso(false);
    setErrors({});
    setSuccessMessage('');
  };

  // Carregar dados quando orderDetails muda
  useEffect(() => {
    if(orderDetails && orderDetails.id){
       setVida(orderDetails.vida || '');
       setModelo(orderDetails.pneuModeloId || (orderDetails.pneuModelo && orderDetails.pneuModelo.id));
       setMarca((orderDetails.pneuModelo && orderDetails.pneuModelo.pneuFabricanteId) || null);
       setBanda(orderDetails.pneuBandaId || '');
       setMedida(orderDetails.pneuMedidaId || '');
       setDot(orderDetails.dot || '');
       setMarcaFogo(orderDetails.marcaFogo || '');
    }
  }, [orderDetails]);

  const handleClose = () => {
    resetAllForm();
    closeDialog();
  };

  // Função de validação
  const validateForm = () => {
    const newErrors = {};

    if (!osCodigo || osCodigo.trim() === '') {
      newErrors.osCodigo = 'Número de Ordem de Serviço é obrigatório';
    }

    if (!marca) {
      newErrors.marca = 'Marca/Fabricante é obrigatória';
    }

    if (!modelo) {
      newErrors.modelo = 'Modelo é obrigatório';
    }

    if (!medida) {
      newErrors.medida = 'Medida é obrigatória';
    }

    if (!banda) {
      newErrors.banda = 'Banda é obrigatória';
    }

    if (!posicao || posicao === '') {
      newErrors.posicao = 'Posição na Autoclave é obrigatória';
    }

    if (!vida || vida === '') {
      newErrors.vida = 'Vida é obrigatória';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addNewAutoclaveCicloOrdemServico = async() => {
    // Validar antes de enviar
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      setErrors({});
      setSuccessMessage('');

      // Garantir que modelo tem as propriedades necessárias
      if (!modelo || !modelo.id) {
        setErrors({ modelo: 'Modelo inválido selecionado' });
        setLoading(false);
        return;
      }

      const obj = {
        "almofada": almofada || '',
        "maquinaId": parseInt(autoclaveCodigo) || 0,
        "maquinaCiclo": parseInt(ciclo) || 0,
        "maquinaPosicao": parseInt(posicao) || 0,
        "descricao": descricao || '',
        "envelope": envelope || '',
        "inner": inner || '',
        "os": osCodigo.trim(),
        "reprocesso": reprocesso,
        "sacoDeAr": sacoDeAr || '',
        "dot": dot.trim() || '',
        "marcaFogo": marcaFogo || '',
        "vida": parseInt(vida) || 0,
        "pneuFabricanteId": modelo.pneuFabricanteId || (marca && parseInt(marca.id)) || 0,
        "pneuModeloId": parseInt(modelo.id) || 0,
        "pneuMedidaId": parseInt((medida && medida.id) || medida) || 0,
        "bandaId": parseInt((banda && banda.id) || banda) || 0,
        "etapaId": 22
      };

      console.log("Salvando dados:", obj);
      await addAutoclaveCicloOrdemServico(obj);

      setSuccessMessage('Ordem de Serviço salva com sucesso!');
      setTimeout(() => {
        resetAllForm();
        closeDialog();
      }, 1500);

    } catch (error) {
      console.error("Erro ao salvar:", error);
      setErrors({
        submit: (error && error.message) || 'Erro ao salvar. Tente novamente.'
      });
    } finally {
      setLoading(false);
    }
  };

  // Botão Novo/Salvar
  const handleSaveNew = async() => {
    await addNewAutoclaveCicloOrdemServico();
  };


  const handleChange = event => {
    setReprocesso(event.target.checked);
  };

  const onOrderIdChanged = (event) => {
    const orderID = event.target.value;
    setOrderId(orderID);
    setErrors({});

    if (orderID && orderID.trim().length > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        try {
          getServiceOrderDetail(orderID);
        } catch (error) {
          console.error("Erro ao buscar ordem de serviço:", error);
          setErrors({ osCodigo: 'Erro ao buscar ordem de serviço' });
        }
      }, 1000);
    }
  };


  const mId = (typeof(marca) === "undefined" || marca === null)?  '' : ( marca.id? marca.id : (marca? marca :  '') );

  return (
    <div>
      <Dialog fullWidth maxWidth={'md'} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          Nova Ordem Serviço - Autoclave: {autoclaveCodigo} | Ciclo: {ciclo}
        </DialogTitle>
        <DialogContent>
          {/* Mensagens de erro */}
          {Object.keys(errors).length > 0 && (
            <Alert severity="error" className={classes.alertError}>
              <strong>Erros no formulário:</strong>
              <ul style={{ marginTop: '8px', marginBottom: 0 }}>
                {Object.entries(errors).map(([key, value]) => (
                  <li key={key}>{value}</li>
                ))}
              </ul>
            </Alert>
          )}

          {/* Mensagem de sucesso */}
          {successMessage && (
            <Alert severity="success" className={classes.alertError}>
              {successMessage}
            </Alert>
          )}

          <Grid item xs={12} container spacing={3}>

            <Grid item xs={12} md={12}  lg={12} xl={12} container>
              <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                <Grid item xs={12} md={12}  lg={12} xl={12} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="order-label-placeholder" className={classes.relative}>
                      Num. Ordem Servico
                    </InputLabel>
                    <TextField
                      autoFocus
                      id="order"
                      label=""
                      type="text"
                      onChange={onOrderIdChanged}
                      value={osCodigo}
                      className={classes.textControl}
                      error={!!errors.osCodigo}
                      helperText={errors.osCodigo}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>
              </Grid>


              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl} error={!!errors.marca}>
                          <PneuFabricanteSelector
                              value={marca}
                              onChange={e => setMarca(e)}
                          />
                          {errors.marca && <p style={{color: '#f44336', fontSize: '0.75rem', marginTop: '4px'}}>{errors.marca}</p>}
                      </FormControl>
                  </Grid>


                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl} error={!!errors.modelo}>
                          <PneuModeloSelector
                              value={modelo}
                              onChange={e => setModelo(e)}
                              marcaId={mId}
                          />
                          {errors.modelo && <p style={{color: '#f44336', fontSize: '0.75rem', marginTop: '4px'}}>{errors.modelo}</p>}
                      </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl} error={!!errors.medida}>
                          <PneuMedidaSelector
                              value={medida}
                              onChange={e => setMedida(e)}
                          />
                          {errors.medida && <p style={{color: '#f44336', fontSize: '0.75rem', marginTop: '4px'}}>{errors.medida}</p>}
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}  lg={2} container>
                      <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="vida-label-placeholder" className={classes.relative}>
                              Vida
                          </InputLabel>
                          <Select
                              value={vida}
                              onChange={e => setVida(e.target.value)}
                              inputProps={{
                                  name: 'vida',
                                  id: 'vida-label-placeholder',
                              }}
                              displayEmpty
                              name="age"
                              className={classes.selectEmpty}
                              readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                              error={!!errors.vida}
                          >
                              <MenuItem value="">
                                  <em>Selecione</em>
                              </MenuItem>
                              <MenuItem value="1" >1</MenuItem>
                              <MenuItem value="2" >2</MenuItem>
                              <MenuItem value="3" >3</MenuItem>
                              <MenuItem value="4" >4</MenuItem>
                              <MenuItem value="5" >5</MenuItem>

                          </Select>
                          {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                      </FormControl>
                  </Grid>


              </Grid>


                <Grid item xs={12} md={12}  lg={12} container>
                    <Grid item xs={12} md={6}  lg={6} container>
                        <FormControl className={classes.formControl} error={!!errors.banda}>
                            <BandaSelector
                                value={banda}
                                onChange={e => setBanda(e)}
                            />
                            {errors.banda && <p style={{color: '#f44336', fontSize: '0.75rem', marginTop: '4px'}}>{errors.banda}</p>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl} error={!!errors.posicao}>
                            <InputLabel shrink htmlFor="order-label-placeholder" className={classes.relative}>
                                Posicao na Autoclave
                            </InputLabel>
                            <Select
                                value={posicao}
                                onChange={e => setPosicao(e.target.value)}
                                inputProps={{
                                    name: 'posicao',
                                    id: 'posicao-label-placeholder',
                                }}
                                displayEmpty
                                name="posicao"
                                className={classes.selectEmpty}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                error={!!errors.posicao}
                            >
                                <MenuItem value="">
                                    <em>Selecione</em>
                                </MenuItem>

                                <MenuItem value="1" >1</MenuItem>
                                <MenuItem value="2" >2</MenuItem>
                                <MenuItem value="3" >3</MenuItem>
                                <MenuItem value="4" >4</MenuItem>
                                <MenuItem value="5" >5</MenuItem>
                                <MenuItem value="6" >6</MenuItem>
                                <MenuItem value="7" >7</MenuItem>
                                <MenuItem value="8" >8</MenuItem>
                                <MenuItem value="9" >9</MenuItem>
                                <MenuItem value="10" >10</MenuItem>
                                <MenuItem value="11" >11</MenuItem>
                                <MenuItem value="12" >12</MenuItem>
                                <MenuItem value="13" >13</MenuItem>
                                <MenuItem value="14" >14</MenuItem>
                                <MenuItem value="15" >15</MenuItem>
                                <MenuItem value="16" >16</MenuItem>
                                <MenuItem value="17" >17</MenuItem>
                                <MenuItem value="18" >18</MenuItem>
                                <MenuItem value="19" >19</MenuItem>
                                <MenuItem value="20" >20</MenuItem>
                                <MenuItem value="21" >21</MenuItem>
                                <MenuItem value="22" >22</MenuItem>
                                <MenuItem value="23" >23</MenuItem>
                                <MenuItem value="24" >24</MenuItem>


                            </Select>
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
                </Grid>




                <Grid item xs={12} md={12} lg={12} className={classes.row} style={{height:'50px'}} container>
                </Grid>

                <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="dot" className={classes.relative}>
                                dot
                            </InputLabel>
                            <TextField
                                id="dot"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={dot}
                                onChange={e=> setDot(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="marcaFogo" className={classes.relative}>
                                Marca de Fogo
                            </InputLabel>
                            <TextField
                                id="dot"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={marcaFogo}
                                onChange={e=> setMarcaFogo(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>

                </Grid>


              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl}>
                          <InputLabel shrink htmlFor="envelope" className={classes.relative}>
                              Envelope
                          </InputLabel>
                          <TextField
                              id="envelope"
                              label=""
                              type="text"
                              className={classes.textControl}
                              readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                              value={envelope}
                              onChange={e=> setEnvelope(e.target.value)}
                          />
                          {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                      </FormControl>
                  </Grid>

                <Grid item xs={12} md={3}  lg={3} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="inner" className={classes.relative}>
                      Inner
                    </InputLabel>
                    <TextField
                      id="inner"
                      label=""
                      type="text"
                      className={classes.textControl}
                      value={inner}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                      onChange={e => setInner(e.target.value)}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}  lg={3} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="Almofada" className={classes.relative}>
                      Almofada
                    </InputLabel>
                    <TextField
                      id="Almofada"
                      label=""
                      type="text"
                      className={classes.textControl}
                      value={almofada}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                      onChange={e => setAlmofada(e.target.value)}
                      error={!!errors.almofada}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}  lg={3} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="saco-ar" className={classes.relative}>
                      Saco ar
                    </InputLabel>
                    <TextField
                      id="saco-ar"
                      label=""
                      type="text"
                      className={classes.textControl}
                      value={sacoDeAr}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                      onChange={e => setSacoDeAr(e.target.value)}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={12} className={classes.row} container>


                <Grid item xs={12} md={3}  lg={2} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="reprocesso" className={classes.relative}>
                      Reprocesso
                    </InputLabel>
                    <Switch
                      id="reprocesso"
                      checked={reprocesso}
                      onChange={handleChange}
                      value="checkedB"
                      color="primary"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      className={classes.switchControl}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}  lg={8} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="descricao" className={classes.relative}>
                      descricao
                    </InputLabel>
                    <TextField
                      id="descricao"
                      label=""
                      type="text"
                      className={classes.textControl}
                      value={descricao}
                      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                      onChange={e => setDescricao(e.target.value)}
                    />
                    {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                  </FormControl>
                </Grid>
              </Grid>

            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSaveNew}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={20} style={{ marginRight: 8 }} />
                Salvando...
              </>
            ) : (
              'Salvar'
            )}
          </Button>
          <Button onClick={handleClose} color="default" disabled={loading}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.id !== null,
    // userId : state.auth.userId,
    // name: state.auth.name,
    // auth: state.auth,
    TireBands: state.tires.bandas.data || [],
    TireBrands: state.tires.fabricantes.data || [],
    TireModels: state.tires.modelos.data || [],
    TireSizes: state.tires.medidas.data || [],
     orderDetails: state.ordemServicoReducer.ordemServico ,
   // processData: state.orderDetails.processData,
    // serviceId: state.orderDetails.serviceId,
  }
}

export default connect(mapStateToProps, {
  getServiceOrderDetail,
  getServiceOrderProcessDetail,
  getServiceOrderServiceDetail,
  addServiceOrders,
  addAutoclaveCicloOrdemServico
})(FullScreenDialog)
